import _ from 'lodash';
import { SDLUtil, RequestUtil } from '@/utils';

const setProjectComboList = ({ commit }, data) => {
  commit('SET_PROJECT_COMBO_LIST', data);
};

// louis
/* 프로젝트목록 변이 실행 * */
const setUserProjectList = ({ commit }, data) => {
  commit('SET_USER_PROJECT_LIST', data);
};

/* 프로젝트 상세 변이 실행 * */
const setProjectDetail = ({ commit }, data) => {
  commit('SET_PROJECT_DETAIL', data);
};

/* 프로젝트 CSP 목록 변이 실행 * */
const setProjectCspList = ({ commit }, data) => {
  commit('SET_PROJECT_CSP_LIST', data);
};


/* 프로젝트 환경(ENV) 변이 실행 * */
const setProjectEnvs = ({ commit }, data) => {
  commit('SET_PROJECT_ENVS', data);
};

/* 리소스 유저 목록 변이 실행 * */
const setResourceUserList = ({ commit }, data) => {
  commit('SET_RESOURCE_USER_LIST', data);
};

/* Common Resource(EC2, DBA) 프로젝트 유저 목록 변이 실행 * */
const setServiceMembersList = ({ commit }, data) => {
  commit('SET_SERVICE_MEMBERS_LIST', data);
};

/* Common Resource(EC2, DBA) 전체 유저 목록 변이 실행 * */
const setAllUserList = ({ commit }, data) => {
  commit('SET_ALL_USER_LIST', data);
};

export default {
  async GET_PROJECT_COMBO_LIST(store) {
    const response = await RequestUtil.get(`${SDLUtil.API_URL}/rem/service/getProjectForComboBox`);
    setProjectComboList(store, response.data.data);
    return response;
  },

  // louis
  /* Main Actions. start * */
  /* 초기화 * */
  initData({ commit }, data) {
    commit('INIT_DATA', data);
  },

  /* 프로젝트 목록 조회 * */
  async getUserProjectList(store, params) {
    const question = '?';
    const paramUri = [];
    for (const [key] of Object.entries(params)) {
      paramUri.push(`${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`);
    }

    // const response = await RequestUtil.get(`${SDLUtil.API_URL}/rem/service/GetUserServiceList?groupByFlag=Y`);
    const response = await RequestUtil.get(`${SDLUtil.API_URL}/rem/service/GetUserProjectList${question}${paramUri.join('&')}`);
    const userProjectList = response.data.data;

    if (!_.isEmpty(userProjectList) && userProjectList.rows.length > 0) {
      userProjectList.rows.forEach(project => {
        project.selected = false;
      });

      userProjectList.rows[0].selected = true;
    }

    setUserProjectList(store, userProjectList);
    return response;
  },

  /* 프로젝트 상세 조회 * */
  async getProjectDetail(store, params) {
    const response = await RequestUtil.post(`${SDLUtil.API_URL}/rem/service/GetProjectDetail`, params);
    const projectDetail = response.data.data;

    const envs = [];
    projectDetail.forEach(data => envs.push(data.env));
    const set = new Set(envs);
    const uniqueEnvs = [...set];

    const resourceList = SDLUtil.getCommCodeList({ commCodeTypeId: 'REM_RESOURCE_TYPE' });
    const newProjectDetail = [];

    // 코드 기준으로 Sort
    resourceList.forEach(resource => {
      projectDetail.forEach(pd => {
        if (String(pd.rsrcTypeCd) === String(resource.code)) {
          newProjectDetail.push(pd);
        }
      });
    });

    setProjectDetail(store, newProjectDetail);
    setProjectEnvs(store, uniqueEnvs);
    return response;
  },

  /* 해당 리소스의 유저 목록 조회 * */
  async getResourceUserList(store, params) {
    const response = await RequestUtil.post(`${SDLUtil.API_URL}/rem/service/GetProjectResourceUsersList`, params);
    const userResourceList = response.data.data;
    setResourceUserList(store, userResourceList);
    return response;
  },

  /* Personal Data 권한 수정(Y, N) * */
  async updatePrivateDataAccess(store, params) {
    const response = await RequestUtil.post(`${SDLUtil.API_URL}/rem/user/PrivateDataAccess`, params);
    return response;
  },

  /* Role 권한 수정 * */
  async updateGrantAccess(store, params) {
    if (params.length == undefined) params = [params];
    const response = await RequestUtil.post(`${SDLUtil.API_URL}/rem/user/GrantAccess`, params);

    return response;
  },

  /* Withdraw. 권한 삭제 * */
  async updateRevokeAccess(store, params) {
    const response = await RequestUtil.post(`${SDLUtil.API_URL}/rem/user/RevokeAccess`, params);
    return response;
  },
  /* Main Actions. end * */

  /* Popup Actions. start * */
  /* Common Resource(EC2, DBA) 프로젝트 유저 목록 조회 * */
  // async getServiceMembersList(store, projectUid) {
  async getServiceMembersList(store, params) {
    // const response = await RequestUtil.post(`${SDLUtil.API_URL}/rem/service/GetServiceMembersList/${projectUid}`);
    const response = await RequestUtil.post(`${SDLUtil.API_URL}/rem/service/GetProjectMembersList`, params);
    // const serviceMembersList = response.data.data;
    const userList = response.data.data;
    _.forEach(userList, user => {
      if (_.isEmpty(user.userName)) user.userName = '';
      if (_.isEmpty(user.enUserName)) user.enUserName = '';
    });

    const serviceMembersList = userList.sort((a, b) => a.userName.localeCompare(b.userName));

    setServiceMembersList(store, serviceMembersList);
    return response;
  },

  /* Common Resource(EC2, DBA) 전체 유저 목록 조회 * */
  // async getAllUserList(store, params) {
  async getAllUserList(store, params) {
    // const response = await RequestUtil.get(`${SDLUtil.API_URL}/rem/user/GetAllUser`);
    const response = await RequestUtil.post(`${SDLUtil.API_URL}/rem/user/GetAllUserList`, params);

    const userList = response.data.data;
    _.forEach(userList, user => {
      if (_.isEmpty(user.userName)) user.userName = '';
      if (_.isEmpty(user.enUserName)) user.enUserName = '';
    });

    const allUserList = userList.sort((a, b) => a.userName.localeCompare(b.userName));

    setAllUserList(store, allUserList);
    return response;
  },

  /* Popup Actions. end * */

  /* 프로젝트의 CSP Type 조회 * */
  async getProjectCspList(store, params) {
    const response = await RequestUtil.post(`${SDLUtil.API_URL}/rem/service/GetProjectCspList`, params);
    const projectCspList = response.data.data;

    setProjectCspList(store, projectCspList);
    return response;
  },
};



// WEBPACK FOOTER //
// ./src/vuex/rem/project/projectActions.js